"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CRM_SAVE = exports.CRM_CONFIRM_RECEIVE_PATIENT = exports.CRM_INIT = void 0;
exports.CRM_INIT = 'kyruus::init';
exports.CRM_CONFIRM_RECEIVE_PATIENT = 'kyruus::connected';
exports.CRM_SAVE = 'kyruus::save';
//# sourceMappingURL=postMessageEvents.js.map